var map = {
	"./avatar.png": "or2j",
	"./city.png": "ylXB",
	"./fields.png": "BJMF",
	"./identity.png": "PqVk",
	"./learning.png": "taj8",
	"./lock.png": "1A2q",
	"./media.png": "z8Qq",
	"./tag.png": "8G4B",
	"./其他.png": "JA4T",
	"./十万.png": "1M2r",
	"./千万.png": "jBfK",
	"./央级.png": "slw9",
	"./媒体.png": "AjrC",
	"./报纸.png": "MeyF",
	"./政务.png": "KVca",
	"./时事.png": "PnDO",
	"./百万.png": "Fj56",
	"./科技.png": "d/JD",
	"./财经.png": "7sA0",
	"./重要KOL.png": "/DTI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1gzu";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/event ^\.\/.*\.png$
// module id = 1gzu
// module chunks = 32